import { render, staticRenderFns } from "./EventsViewPage.vue?vue&type=template&id=5542b6d4&scoped=true"
import script from "./EventsViewPage.vue?vue&type=script&lang=ts"
export * from "./EventsViewPage.vue?vue&type=script&lang=ts"
import style0 from "./EventsViewPage.vue?vue&type=style&index=0&id=5542b6d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5542b6d4",
  null
  
)

export default component.exports